<template>
  <div class="venue-groups">
    <header>
      <h1>{{ $t('global.venues') }}</h1>
      <router-link
        :to="{ name: 'admin-venue-groups-new' }"
        class="button button--primary">
        <span>Add New {{ $helpers.remapNaming('venue') }}</span>
      </router-link>
    </header>
    <ez-table
      :data="groups"
      :headers="{
        registeredAt: () => 'Date registered',
      }"
      :columns="['name', 'registeredAt', 'status']"
      :columnProps="{
        status: { class: 'medium-cell' },
        registeredAt: { class: 'date-cell' },
      }"
      @rowClick="openVenueGroup"
      :loading="isLoading"
    >
      <template #cell-name="{ row }">
        <v-venue-entity-info :venue="row" />
      </template>
      <template #cell-registeredAt="{ row: { registeredAt } }">
        <div v-if="registeredAt">{{ registeredAt|date }}</div>
        <div v-else>-</div>
      </template>
      <template #cell-status="{ row: { status } }">
        <status-badge :status="status || 'draft'"></status-badge>
      </template>
    </ez-table>
  </div>
</template>

<script>
import VVenueEntityInfo from '@/components/v3/patterns/VVenueEntityInfo';
import { mapActions, mapGetters } from 'vuex';
import EzTable from '@/components/ui/Table';
import StatusBadge from '@/views/common/status-badge';
import Group from '@/models/Group';

export default {
  components: {
    VVenueEntityInfo,
    EzTable,
    StatusBadge,
  },
  computed: {
    groups() {
      return Group.query().orderBy(n => n.name.toLowerCase()).all();
    },
    ...mapGetters('loading', ['getLoading']),
    isLoading() {
      return this.getLoading('get-venue-groups');
    },
  },
  methods: {
    openVenueGroup({ id }) {
      this.$router.push({
        name: 'admin-venue-groups-info',
        params: {
          groupId: id,
        },
      });
    },
    ...mapActions('entities/groups', [
      'fetchGroups',
    ]),
  },
  async mounted() {
    await this.fetchGroups();
  },
};
</script>

<style scoped lang="scss">
.venue-groups {
  @extend %list;
  min-height: $loading-min-height;
  a.button {
    @extend %base-button;
    @include button-type('primary',
      $button-primary-bg,
      $button-primary-color,
      $button-primary-hover-bg,
      $button-primary-color
    ) {
      &:hover {
        background-color: $button-primary-hover-bg;
      }
      &:active {
        background-color: $button-primary-bg;
      }
      text-decoration: none;
    };
  }
}
</style>
